import { Injectable } from "@angular/core";
import { LinhaTrecho } from "@tivic-team/manager-ts/dist/mob/entities/linha/linha-trecho.entity";
import { LinhaTrechoDTO } from "app/model/dtos/mob/linha-trecho.dto";
import { LinhaTrechoController } from "../../controllers/mob/linha-trecho.controller";
import { ApiService } from "../api-service.interface";
import { LoaderService } from "../loader.service";
import { LinhaTrechoDTOSearch } from "./linha-trecho-dto.search";

@Injectable()
export class LinhaTrechoService implements ApiService<LinhaTrechoDTO> {
  
  constructor(
    private _linhaTrechoController: LinhaTrechoController, 
    private _loaderService: LoaderService
  ) {}

  create(entity: LinhaTrechoDTO): Promise<LinhaTrechoDTO> {
    this._loaderService.show();
    return this._linhaTrechoController.create(entity).finally(() => this._loaderService.hide());
  }

  update(entity: LinhaTrechoDTO): Promise<LinhaTrechoDTO> {
    this._loaderService.show();
    return this._linhaTrechoController.update(entity).finally(() => this._loaderService.hide());
  }

  updateLinhaTrechoColetivoRural(entity: LinhaTrechoDTO): Promise<LinhaTrechoDTO> {
    this._loaderService.show();
    return this._linhaTrechoController.updateLinhaTrechoColetivoRural(entity).finally(() => this._loaderService.hide());
  }

  async save(linhaTrecho: LinhaTrechoDTO): Promise<LinhaTrechoDTO> {
    this._loaderService.show();
    if (linhaTrecho.cdLinha && linhaTrecho.cdLinha > 0 
        && linhaTrecho.cdRota && linhaTrecho.cdRota > 0 
        && linhaTrecho.cdTrecho && linhaTrecho.cdTrecho > 0
    ){
        return this._linhaTrechoController.update(linhaTrecho).finally(() => this._loaderService.hide());
    } else {
        return this._linhaTrechoController.create(linhaTrecho).finally(() => this._loaderService.hide());
    }
  }

  async saveLinhaTrechoColetivoRural(linhaTrecho: LinhaTrechoDTO): Promise<LinhaTrechoDTO> {
    this._loaderService.show();
    if (linhaTrecho.cdLinha && linhaTrecho.cdLinha > 0 
        && linhaTrecho.cdRota && linhaTrecho.cdRota > 0 
        && linhaTrecho.cdTrecho && linhaTrecho.cdTrecho > 0
    ){
        return this._linhaTrechoController.updateLinhaTrechoColetivoRural(linhaTrecho).finally(() => this._loaderService.hide());
    } else {
        return this._linhaTrechoController.createLinhaTrechoColetivoRural(linhaTrecho).finally(() => this._loaderService.hide());
    }
  }

  ordernar(itinerarios: LinhaTrechoDTO[]): Promise<LinhaTrechoDTO[]> {
    this._loaderService.show();
    return this._linhaTrechoController.ordernar(itinerarios).finally(() => this._loaderService.hide());
  }

  find(search?: LinhaTrechoDTOSearch): Promise<Array<LinhaTrechoDTO>> {
    this._loaderService.show();
    return this._linhaTrechoController.find(search && search.getFilters() || null).finally(() => this._loaderService.hide());
  }

  findTrechos(search?: LinhaTrechoDTOSearch): Promise<Array<LinhaTrechoDTO>> {
    this._loaderService.show();
    return this._linhaTrechoController.findTrechos(search && search.getFilters() || null).finally(() => this._loaderService.hide());
  }

  findIntinerarios(search?: LinhaTrechoDTOSearch): Promise<Array<LinhaTrechoDTO>> {
    this._loaderService.show();
    return this._linhaTrechoController.findIntinerarios(search && search.getFilters() || null).finally(() => this._loaderService.hide());
  }
  
  async remove(cdLinha: number, cdRota: number, cdTrecho: number): Promise<LinhaTrecho> {
    this._loaderService.show();
    return this._linhaTrechoController.remove(cdLinha, cdRota, cdTrecho).finally(() => this._loaderService.hide());
  }

  async removeTrechoColetivoRural(cdLinha: number, cdRota: number, cdTrecho: number): Promise<LinhaTrecho> {
    this._loaderService.show();
    return this._linhaTrechoController.removeTrechoColetivoRural(cdLinha, cdRota, cdTrecho).finally(() => this._loaderService.hide());
  }

  get(...args: number[]): Promise<LinhaTrechoDTO> {
    throw new Error("Method not implemented.");
  }
}
